<button mat-button (click)="goToPreviousSeason()" [disabled]="!hasPreviousSeason()"><mat-icon>chevron_left</mat-icon></button>
@if (activeSeason()) {
    <button class="season-select" mat-button [matMenuTriggerFor]="menu">
        @if (activeSeason()?.id) {
            <span>{{ activeSeason()?.name }}</span>
        } @else {
            <span>{{ 'SEASONS.ALL' | translate }}</span>
        }
    </button>
}
<button mat-button (click)="goToNextSeason()" [disabled]="!hasNextSeason()"><mat-icon>chevron_right</mat-icon></button>
<mat-menu #menu="matMenu">
    @for (s of main(); track s.id) {
        <button (click)="selectSeason(s)" mat-menu-item>
            @if (s.id) {
                <span>{{ s.name }}</span>
            } @else {
                <span>{{ 'SEASONS.ALL' | translate }}</span>
            }
        </button>
    }
    @if (older().length) {
        <button mat-menu-item [matMenuTriggerFor]="others">{{ 'SEASONS.OLDER' | translate }}</button>
    }
</mat-menu>

<mat-menu #others="matMenu">
    @for (s of older(); track s.id) {
        <button (click)="selectSeason(s)" mat-menu-item>
            {{ s.name }}
        </button>
    }
</mat-menu>
